/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */

import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject ,  Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class CompensationAnalyticsService {
  private masterColumnsAndFiltersUrl: string = environment.host + '/compensation/analytics/metadata';
  private applyFiltersUrl: string = environment.host + '/compensation/filter';
  private currentPeriodUrl: string = environment.host + '/currentperiod';
  private analyticsReportUrl: string = environment.host + '/report/CompensationReports';
  private multiSortColumns: any = [];
  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;

  constructor(private http: HttpClient) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public getCurrentPeriod(regionCode: string) {
    if (regionCode) {
      return this.http.get(this.currentPeriodUrl + '?regionCode=' + regionCode).toPromise();
    } else {
      return this.http.get(this.currentPeriodUrl).toPromise();
    }
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  public getMultiSortColumns() {
    return this.multiSortColumns;
  }

  public setMultiSortColumns(columns: any) {
    this.multiSortColumns = columns;
  }

  public loadMasterColumnsAndFilters() {
    return this.http.get(this.masterColumnsAndFiltersUrl).toPromise();
  }

  public getMembers(payload: any, startRecord: any, recordsSize: any, periodPosition: any, selectedReport: any) {
    let filterURL, selectedReportName;
    selectedReportName = (selectedReport && selectedReport.name) ? selectedReport.name : '';
    filterURL = this.applyFiltersUrl + '?pageMaxId=' + startRecord + '&size=' + recordsSize + '&currentPeriod=' + ((periodPosition == undefined) ? true : periodPosition) + '&reportName=' + selectedReportName;
    //return this.http.post(filterURL, payload).toPromise();
    return this.http.post(filterURL, payload).pipe(
      map(response => response))
  }

  public getDefaultReportDetails() {
    return this.http.get((this.analyticsReportUrl).toString()).toPromise();
  }

}
